import React from "react";

export type FieldLabelProps = {
  label: string;
  helper?: string;
  required?: boolean;
  children: React.ReactNode;
};

const FieldLabel = ({
  label,
  helper,
  required = false,
  children,
}: FieldLabelProps) => (
  <label className="block">
    <span className="block text-sm font-semibold text-gray-950">
      {label}
      {required && <span className="text-red-500"> *</span>}
    </span>
    {helper && (
      <span className="mt-1 block text-sm leading-5 text-black">
        {helper}
      </span>
    )}
    <div className="mt-2">{children}</div>
  </label>
);

export default FieldLabel;
